import React, { useCallback, useEffect, useState } from 'react';
import { useFiltersGlobalState } from './filtersGlobalState';

export const useDropdownMenuFilters = (props, setSelectedFiltersWithSubFilters, filters) => {
    const [selectedFiltersWithSubFiltersMap] = useFiltersGlobalState();
    const [selectedFilter, setSelectedFilter] = useState(null);
    const [filteredChildren, setFilteredChildren] = useState([]);

    useEffect(() => {
        setFilteredChildren(prev =>
            React.Children.toArray(props.children).filter(child => {
                if (child.props.children === 'No options') {
                    return true;
                }
                const childData = child.props.data;
                return Object.values(selectedFiltersWithSubFiltersMap).every(filter => {
                    const { selectedFilter, selectedSubFilters } = filter;

                    if (!selectedSubFilters || selectedSubFilters.length === 0) {
                        return prev.contains(child);
                    }

                    return selectedSubFilters
                        .map(subFilter => subFilter.filterValue)
                        .includes(childData[selectedFilter.fieldName]);
                });
            })
        );
    }, [props.children, selectedFiltersWithSubFiltersMap]);

    const onSelectFilter = useCallback(value => {
        setSelectedFilter(value);
    }, []);

    const onSelectSubFilter = useCallback(
        value => {
            const prevSelectedSubFilters =
                selectedFiltersWithSubFiltersMap[selectedFilter.name]?.selectedSubFilters || [];
            const updatedSubFilters = prevSelectedSubFilters.includes(value)
                ? prevSelectedSubFilters.filter(item => item !== value)
                : [...prevSelectedSubFilters, value];

            setSelectedFiltersWithSubFilters({ selectedFilter, selectedSubFilters: updatedSubFilters });
        },
        [selectedFilter, selectedFiltersWithSubFiltersMap, setSelectedFiltersWithSubFilters]
    );

    const onclickSelectedFilter = useCallback(filter => {
        setSelectedFilter(filter);
    }, []);

    const onRemoveSelectedFilter = useCallback(
        (filter, subFilter) => {
            const prevSelectedSubFilters = selectedFiltersWithSubFiltersMap[filter.name]?.selectedSubFilters || [];
            const updatedSubFilters = prevSelectedSubFilters.includes(subFilter)
                ? prevSelectedSubFilters.filter(item => item !== subFilter)
                : [...prevSelectedSubFilters, subFilter];

            setSelectedFiltersWithSubFilters({ selectedFilter: filter, selectedSubFilters: updatedSubFilters });
        },
        [selectedFiltersWithSubFiltersMap, setSelectedFiltersWithSubFilters]
    );

    const getValuesForSelectedFilter = selectedFilter => {
        const filter = filters.find(filter => filter.name === selectedFilter.name);
        return filter ? filter.subFilters : [];
    };

    const getSubFiltersForSelectedFilter = selectedFilter => {
        return selectedFiltersWithSubFiltersMap[selectedFilter.name]?.selectedSubFilters || [];
    };

    const getSelectedFiltersFormMap = () => {
        return Object.values(selectedFiltersWithSubFiltersMap);
    };

    return {
        selectedFilter,
        onSelectFilter,
        setSelectedFilter,
        getValuesForSelectedFilter,
        onSelectSubFilter,
        getSubFiltersForSelectedFilter,
        getSelectedFiltersFormMap,
        onclickSelectedFilter,
        onRemoveSelectedFilter,
        filteredChildren,
    };
};
